import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareDateTimeAttributePropertyValues =
    AttributePropertyValues
    & {
        isLocal: boolean;
    };

export type ClientAwareDateTimeAttributeProperties = {
    [name in keyof ClientAwareDateTimeAttributePropertyValues]?: ClientAwareDateTimeAttributePropertyValues[name];
};

export interface IClientAwareDateTimeAttribute extends IAttribute, ClientAwareDateTimeAttributeProperties
{
}

export class ClientAwareDateTimeAttribute extends Attribute implements IClientAwareDateTimeAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareDateTimeAttribute";
    public static override className = "ClientAwareDateTimeAttribute";

    public isLocal?: boolean;

    constructor(propertyValues?: Partial<ClientAwareDateTimeAttributePropertyValues>)
    {
        super(propertyValues);

        this.isLocal = propertyValues?.isLocal;
    }
}